
export enum MailState {
    UNREAD,
    READ,
}